(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/leia-open-popup-error-handler.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/leia-open-popup-error-handler.js');
"use strict";


const showErrorMessage = (errorMessage, callback) => {
  svs.components.dialog.api.add(new svs.components.dialog.Confirm({
    branding: svs.components.dialog.branding.TUR,
    type: svs.components.dialog.type.ERROR,
    title: 'Tekniskt fel',
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: errorMessage
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        callback();
        svs.components.dialog.api.close();
      }
    }]
  }));
};
const getErrorMessage = error => {
  var _error$context;
  switch (true) {
    case Boolean(error === null || error === void 0 || (_error$context = error.context) === null || _error$context === void 0 ? void 0 : _error$context.reconciliationState):
      return 'Just nu tar det lite längre tid att föra över vinsten till ditt spelkonto. Vid bestående problem kontakta Kundservice.';
    default:
      return 'Tillfälligt anslutningsproblem. Du hittar dina betalade spel i Mina spel. Vid bestående problem kontakta kundservice.';
  }
};

const handleOpenPopError = (error, callback) => {
  var _error$context2;
  const {
    showNationalSuspensionPayMessage
  } = svs.accountservices.national_suspension_message;
  const {
    UserLowBalance
  } = svs.tur.payment.dialogs;
  switch (error === null || error === void 0 || (_error$context2 = error.context) === null || _error$context2 === void 0 ? void 0 : _error$context2.message) {
    case 'CUSTOMER_SUSPENDED':
      svs.tur.apierrors.showErrorMessage({
        response: 1019,
        onConfirm: callback
      });
      break;
    case 'E_CUSTOMER_BLOCKED':
      svs.tur.apierrors.showErrorMessage({
        response: 26107,
        onConfirm: callback,
        fallbackTitle: 'Hoppsan!'
      });
      break;
    case 'NATIONAL_BLOCKED':
      showNationalSuspensionPayMessage(callback);
      break;
    case 'KYC_SELL_DISABLED':
      svs.tur.apierrors.showErrorMessage({
        response: 6332,
        onConfirm: callback
      });
      break;
    case 'CARETECH_BLOCKED':
      svs.tur.apierrors.showErrorMessage({
        response: 5139,
        onConfirm: callback
      });
      break;
    case 'NOT_ENOUGH_MONEY':
      new UserLowBalance({
        onCancel: callback
      });
      break;
    case 'DEPOSIT_BUDGET_NOT_SET':
      svs.tur.apierrors.showErrorMessage({
        response: 6289
      });
      break;
    case 'BAD_BET':
    default:
      showErrorMessage(getErrorMessage(error), callback);
  }
};
setGlobal('svs.ticketgames.ticketUtility.utils.handleOpenPopError', handleOpenPopError);

 })(window);